import moment from 'moment';
import _ from 'lodash';

const getFormatedDate = (date) => {
  return moment(date).format('MMM DD/YYYY');
};

const getFormatedTime = (time) => {
  return time.slice(0, -3);
};

const groupTicketsByDate = ({ items }) => {
  const resultsGroupedByDay = _(items)
    .groupBy((ticket) =>
      moment(ticket.created_at).hours(0).minutes(0).seconds(0).milliseconds(0).format()
    )
    .value();
  const gkeys = Object.keys(resultsGroupedByDay);
  const mapped = gkeys.map((key) => ({
    date: key,
    label: getFormatedDate(key),
    tickets: resultsGroupedByDay[key].sort((a, b) =>
      moment(a.created_at).isAfter(moment(b.created_at))
    ),
  }));
  const mappedAndSorted = mapped.sort((a, b) => moment(a.date).isAfter(moment(b.date)));
  return mappedAndSorted;
};

export { getFormatedDate, getFormatedTime, groupTicketsByDate };
